"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var PaymentFormItemsTable_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Payment/PaymentFormPage/PaymentFormItemsTable.vue"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var PhoneNumber_vue_1 = __importDefault(require("@/Views/Components/Misc/PhoneNumber.vue"));
var AddressInput_vue_1 = __importDefault(require("@/Views/Components/Misc/AddressInput.vue"));
var CreditCardForm_vue_1 = __importDefault(require("@/Views/Components/Misc/CreditCardForm.vue"));
var PaymentFormPageSubmitButton_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Payment/PaymentFormPage/PaymentFormPageSubmitButton.vue"));
var PaymentFormPageBillingCard_vue_1 = __importDefault(require("@/Views/Components/Project/Pages/Payment/PaymentFormPage/PaymentFormPageBillingCard.vue"));
var toastNotification_1 = __importDefault(require("@/Modules/Misc/toastNotification"));
var PaymentFormPage = /** @class */ (function (_super) {
    __extends(PaymentFormPage, _super);
    function PaymentFormPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            billingFirstName: "",
            billingLastName: "",
            billingAddress: {
                street: "",
                street2: "",
                city: "",
                state: "",
                zip: ""
            },
            shippingAddress: {
                street: "",
                street2: "",
                city: "",
                state: "",
                zip: ""
            },
            billingEmail: "",
            billingIsSameAsShippingAddress: true,
            billingPhone: "",
            totalCost: 0,
            userId: null,
            selected: [],
            creditCardCVV: "",
            creditCardExpMonth: 1,
            creditCardExpYear: 2022,
            creditCardNumber: "",
        };
        _this.formSubmitToggle = false;
        return _this;
    }
    Object.defineProperty(PaymentFormPage.prototype, "totalCost", {
        get: function () {
            var bids = this.items.map(function (x) { return x.highest_bid_amount; });
            return lodash_1.default.sum(bids);
        },
        enumerable: false,
        configurable: true
    });
    PaymentFormPage.prototype.updateCreditCardData = function (event) {
        this.form.creditCardNumber = event.creditCardNumber;
        this.form.creditCardCVV = event.creditCardCVV;
        this.form.creditCardExpMonth = event.creditCardExpMonth;
        this.form.creditCardExpYear = event.creditCardExpYear;
    };
    PaymentFormPage.prototype.updateForm = function (event) {
        this.form.billingAddress = event.billingAddress;
        this.form.billingEmail = event.billingEmail;
        this.form.billingPhone = event.billingPhone;
        this.form.billingIsSameAsShippingAddress = event.billingIsSameAsShippingAddress;
        this.form.billingFirstName = event.billingFirstName;
        this.form.billingLastName = event.billingLastName;
    };
    PaymentFormPage.prototype.beforeMount = function () {
        var form = {
            billingFirstName: lodash_1.default.clone(this.user.payment_details.first_name),
            billingLastName: lodash_1.default.clone(this.user.payment_details.last_name),
            billingAddress: lodash_1.default.cloneDeep(this.user.payment_details.billing_address),
            shippingAddress: lodash_1.default.cloneDeep(this.user.payment_details.shipping_address),
            billingPhone: lodash_1.default.clone(this.user.payment_details.phone),
            billingEmail: lodash_1.default.clone(this.user.payment_details.email),
            creditCardNumber: "",
            creditCardCVV: "",
            creditCardExpMonth: (0, moment_1.default)().month() + 1,
            creditCardExpYear: (0, moment_1.default)().year(),
            billingIsSameAsShippingAddress: true,
            selected: lodash_1.default.cloneDeep(this.items),
            userId: lodash_1.default.clone(this.user.id),
            totalCost: 0,
        };
        this.form = this.$inertia.form(form);
        if (this.pageMessage && this.pageMessage.message) {
            this.toast(this.pageMessage.message, this.pageMessage.messageColor);
        }
    };
    PaymentFormPage.prototype.toast = function (message, color) {
        (0, toastNotification_1.default)(this.$toast, message, color, {
            timeout: 10000,
            hideProgressBar: false,
            position: "top-center"
        });
    };
    PaymentFormPage.prototype.onPageMessageChanged = function (to, from) {
        if (to && from) {
            this.toast(to.message, to.messageColor);
        }
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            required: true,
            type: Array
        })
    ], PaymentFormPage.prototype, "items", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: false, type: Object })
    ], PaymentFormPage.prototype, "flash", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: false, type: Object })
    ], PaymentFormPage.prototype, "pageMessage", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Object })
    ], PaymentFormPage.prototype, "user", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Boolean })
    ], PaymentFormPage.prototype, "bankIsInactive", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Array })
    ], PaymentFormPage.prototype, "states", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)('pageMessage', { immediate: true, deep: true })
    ], PaymentFormPage.prototype, "onPageMessageChanged", null);
    PaymentFormPage = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                PaymentFormPageBillingCard: PaymentFormPageBillingCard_vue_1.default,
                CreditCardForm: CreditCardForm_vue_1.default,
                PaymentFormItemsTable: PaymentFormItemsTable_vue_1.default,
                PhoneNumber: PhoneNumber_vue_1.default,
                AddressInput: AddressInput_vue_1.default,
                PaymentFormPageSubmitButton: PaymentFormPageSubmitButton_vue_1.default
            }
        })
    ], PaymentFormPage);
    return PaymentFormPage;
}(vue_property_decorator_1.Vue));
exports.default = PaymentFormPage;
